export class Option {
    // The name of the option
    name;
    // The weapons associated with the option
    weapons;
    // The abilities associated with the option
    abilities;
    // Any keywords associated with the option
    keywords;
    // The points cost of the option
    points;
    constructor(name) {
        this.name = name;
        this.weapons = [];
        this.abilities = [];
        this.keywords = [];
        this.points = 0;
    }
}
export default class OptionSet {
    // The name of the option set (group of options)
    name;
    // The options available in the group
    options;
    // The selected option, null if no options have been selected
    selection;
    constructor(name, options) {
        this.name = name;
        this.options = options;
        this.selection = null;
    }
}
